import React, { useState } from 'lib/react';
import clsx from 'lib/clsx';
import {
  EVGrid,
  EVList,
  EVListItem,
  EVLink,
} from 'lib/components';
import { Link } from 'lib/router';
import { SUPPORT_ROUTE } from 'constants/RouteConstants';
import { useTranslation } from 'lib/translation';
import PropTypes from 'prop-types';
import history from 'store/CreateHistory';
import { getUserMenuOptions } from 'utils/app.utils';
import { useSelector } from 'react-redux';
import { isOrderingDisabledSelector, hasTrueDesignAppEntitlementSelector } from 'utils/appSelectors.utils';
import UserProfileButton from './UserProfileButton.component';
import useStyles from '../../HeaderStyles';

function SidebarUserMenu({ handleSidebarClose }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const classes = useStyles();
  const { t } = useTranslation();

  const currentURL = history.location.pathname;
  const handleUserProfileButtonClick = () => setIsMenuOpen((isOpen) => !isOpen);

  const isOrderingDisabled = useSelector(isOrderingDisabledSelector);
  const hasTrueDesignAppEntitlement = useSelector(hasTrueDesignAppEntitlementSelector);

  return (
    <>
      <UserProfileButton
        handleClick={handleUserProfileButtonClick}
        displayName
        isMenuOpen={isMenuOpen}
      />
      {isMenuOpen && (
      <EVGrid item className={classes.headerLinksContainer} component="nav" id="user-menu" style={{ paddingTop: 0 }}>
        <EVList>
          {getUserMenuOptions(isOrderingDisabled, hasTrueDesignAppEntitlement)
            .filter(({ link }) => link !== SUPPORT_ROUTE)
            .map((menuOption) => {
              const LinkComponent = menuOption.base ? EVLink : Link;
              const linkProps = menuOption.base ? { href: `${menuOption.base}${menuOption.link}` } : { to: menuOption.link };
              return (
                <EVListItem className={classes.headerLinksListItem} key={menuOption.name}>
                  <LinkComponent
                    onClick={handleSidebarClose}
                    aria-label={t(menuOption.name)}
                    className={clsx(classes.menuLink, (currentURL === menuOption.link) && classes.selectedMenuLink)}
                    {...linkProps}
                  >
                    {t(menuOption.name)}
                  </LinkComponent>
                </EVListItem>
              );
            })}
        </EVList>
      </EVGrid>
      )}
    </>
  );
}

SidebarUserMenu.propTypes = {
  handleSidebarClose: PropTypes.func.isRequired,
};

export default SidebarUserMenu;
